import React from 'react';
import { styled } from '@compiled/react';
import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { DropIndicator as DropIndicatorUI } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';
import { token } from '@atlaskit/tokens';
import { Tokens } from '@atlassian/jira-custom-theme-constants/src/constants.tsx';
import { TAB_GAP } from '@atlassian/jira-navigation-kit-common/src/index.tsx';

const DropIndicator = ({ closestEdge, testId }: { closestEdge?: Edge | null; testId?: string }) =>
	closestEdge && (
		<DropIndicatorWrapper data-testid={testId}>
			<DropIndicatorUI edge={closestEdge} gap={`${TAB_GAP}px`} />
		</DropIndicatorWrapper>
	);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DropIndicatorWrapper = styled.div({
	position: 'absolute',
	top: token('space.050'),
	left: 0,
	width: '100%',
	height: 'calc(100% - 4px)',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	'--ds-border-selected': Tokens.COLOR_BORDER_SELECTED,
});

export default DropIndicator;
